import { EventEmitter, Injectable, Output } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { EmailTemplateBaseModel } from "../../models/emailTemplates/email-template.model.ts.js";
import { EmailTemplateModalComponent } from "src/app/shared/modals/email-template-modal/email-template-modal.component";

@Injectable({
  providedIn: 'root'
  
})
export class EmailTemplateModalService {

  @Output() modelChanged = new EventEmitter<any>(); 

  constructor(  private modalService: NgbModal) { }

  openModal(model?: EmailTemplateBaseModel) {
    var modalRef!: NgbModalRef;
    modalRef = this.modalService.open( EmailTemplateModalComponent, {windowClass : "myCustomModalClassUnderTopBar", size: 'xxl', centered: false, backdrop: 'static', keyboard: false, scrollable: true });
    if(model){
        modalRef.componentInstance.model = model;
    }
    modalRef.result.then(() => {
        this.modelChanged.emit(true);
        modalRef.componentInstance.ngOnDestroy();
      });
  }
}